export default __webpack_public_path__ + "img/e14361a8a8a5a5adc918ad2bb07837ae.svg";